import apiClient from './client';

export const insightsApi = {
  list(params = {}) {
    return apiClient.get('/insights', params);
  },

  count(params = {}) {
    return apiClient.get('/insights/count', params);
  },

  generate(params = {}) {
    const query = new URLSearchParams(params).toString();
    return apiClient.post(`/insights/generate${query ? `?${query}` : ''}`);
  },

  acknowledge(id) {
    return apiClient.post(`/insights/${id}/acknowledge`);
  },

  dismiss(id) {
    return apiClient.post(`/insights/${id}/dismiss`);
  },
};

export default insightsApi;
